__turbopack_context__.v({
  "content": "Header-module-scss-module__91dsrG__content",
  "wrapper": "Header-module-scss-module__91dsrG__wrapper",
});
